/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
import axios from 'axios';

export function bootstrap() {
  
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

  /**
   * Next we will register the CSRF Token as a common header with Axios so that
   * all outgoing HTTP requests automatically have it attached. This is just
   * a simple convenience so we don't have to attach every token manually.
   */

  const token = document.head.querySelector('meta[name="csrf-token"]') as HTMLMetaElement;

  if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    //    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
  } else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
  }

  // Object compare method
  // FIXME
  // eslint-disable-next-line
  Object.compareObjects = Object.compare = function<T extends Object> (obj1:T, obj2:T) {
    //Loop through properties in object 1
    for (const p in obj1) {
      //Check property exists on both objects
      if (Object.hasOwn(obj1, p) !== Object.hasOwn(obj2, p)) return false;
      //Deep compare objects
      switch (typeof (obj1[p])) {
      case 'object':
        if (!Object.compare(obj1[p], obj2[p])) return false;
        break;
      //Compare function code
      case 'function':
        if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p]?.toString())) return false;
        break;
      //Compare values
      default:
        if (obj1[p] != obj2[p]) return false;
      }
    }
    //Check object 2 for any extra properties
    for (const p in obj2) {
      if (obj1 === null || typeof (obj1) == 'undefined' || typeof (obj1[p]) == 'undefined') return false;
    }
    return true;
  };

  /**
   * Define the chunk method in the prototype of an array
   * that returns an array with arrays of the given size.
   *
   * @param chunkSize {Integer} Size of every group
   */
  /*
  Object.defineProperty(Array.prototype, 'chunk', {
    value(chunkSize:number) {
      const temporal = [];
      for (let i = 0; i < this.length; i += chunkSize) {
        temporal.push(this.slice(i, i + chunkSize));
      }
      return temporal;
    }
  });*/

}
